import cUSDIcon from '../../../media/icons/cUSDO.png';

export function CUSDOIcon() {
    return (
        <img src={cUSDIcon} width={42} height={42} alt='cUSD'/>
    )
}
